import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectPosition } from '../../actions/';
import { positions } from '../config/'

const options = [
    {value: positions.LEFT, label: 'Gauche'},
    {value: positions.UP, label: 'Haut'},
    {value: positions.RIGHT, label: 'Droite'},
    {value: positions.DOWN, label: 'Bas'}
]

class SelectPosition extends Component {

  constructor(props) {
    super(props);
  }

  renderOptions({value, label}) {
    return (
        <option key={value} value={value}>{label}</option>
    )
  }
  onPositionChange(e) {
    this.props.selectPosition(e.target.value)
  }
  render() {
    return (
      <select
        className="form-control btn-info"
        onChange={this.onPositionChange.bind(this)}
        value={this.props.position}
        title="Choisir la position du modèle">
        {options.map(this.renderOptions)}
      </select>
    );
  }
}

const mapStateToProps = ({ position }) => {
  return { position };
}
const mapDispatchToProps = dispatch => {
    return bindActionCreators({ selectPosition }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectPosition)
